import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { CONTACT, waLink } from "@/config/brand";
import { STICKY_BAR } from "@/constants/testIds";

export const StickyMobileBar = () => (
    <div
        data-testid={STICKY_BAR.root}
        className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 backdrop-blur border-t border-[#17252D]/10 px-3 py-2"
        style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 8px)" }}
    >
        <div className="flex gap-2">
            <a
                data-testid={STICKY_BAR.call}
                href={CONTACT.phoneHref}
                className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-lg border border-[#17252D]/15 bg-white py-2.5 text-sm font-medium text-[#17252D] active:scale-[0.99]"
            >
                <Phone className="h-4 w-4" strokeWidth={1.75} /> Call
            </a>
            <a
                data-testid={STICKY_BAR.whatsapp}
                href={waLink()}
                target="_blank"
                rel="noreferrer"
                className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-lg bg-[#25D366] hover:bg-[#20b955] py-2.5 text-sm font-semibold text-white active:scale-[0.99]"
            >
                <MessageCircle className="h-4 w-4" strokeWidth={1.75} /> WhatsApp
            </a>
            <Link
                to="/request-a-quote"
                data-testid={STICKY_BAR.quote}
                className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-lg bg-[#001B3D] py-2.5 text-sm font-semibold text-white"
            >
                <FileText className="h-4 w-4" strokeWidth={1.75} /> Quote
            </Link>
        </div>
    </div>
);
